import Component from "@glimmer/component"
import { scheduleOnce } from "@ember/runloop"
import { action } from "@ember/object"
import { tracked } from "@glimmer/tracking"

interface ButtonRowComponentArgs {
  Args: {
    suggestions: Array<{ title: string; prompt: string }>
  }
}

export default class ButtonRowComponent extends Component<ButtonRowComponentArgs> {
  @tracked visibleCount = this.args.suggestions.length

  buttonRefs: HTMLElement[] = []
  containerRef: HTMLElement | null = null

  @action
  registerContainer(element: HTMLElement) {
    this.containerRef = element
    this.measureVisibleButtons()
  }

  @action
  registerButton(index: number, element: HTMLElement) {
    this.buttonRefs[index] = element
  }

  measureVisibleButtons() {
    const container = this.containerRef
    if (!container) return

    const containerRight = container.getBoundingClientRect().right
    let count = 0

    for (let i = 0; i < this.args.suggestions.length; i++) {
      const btn = this.buttonRefs[i]
      if (!btn) continue

      const btnRight = btn.getBoundingClientRect().right
      // 45 is for the "Show More" button
      if (btnRight < containerRight - 45) {
        count++
      } else {
        break
      }
    }

    this.visibleCount = count
  }
}
